<template>
  <div class="point pointer flex align-center justify-center gobackStyle" @click="goBackFun">
    <img src="@/assets/images/site/arrow_small.png">
    <p>{{title}}</p>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    title: {
      type: String,
      default: "返回"
    },
    isBack:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    
  },
  methods: {
    goBackFun(){
      // if(this.isBack){
      //   // this.$emit("goBackFunc");
      // }else{
      //   this.$router.push({
      //       path: "/pcnationwideSite",
      //       query: {
      //         city:320300
      //       },
      //     });
      // }
      this.$router.push({
            path: "/pcnationwideSite",
            query: {
              city:320300
            },
          });
    }
  }
}
</script>
<style lang="scss" scoped>
  .point{
    font-size: 18px;
    font-weight:500;
    padding:8px 13px;
    width: 164px;
    // height: 52px;
    background: linear-gradient(180deg, rgba(14, 134, 139, 0.88) 0%, rgba(0, 43, 41, 0.6) 100%);
    border: 1px solid #1A7683;
    img{
      width:16px;
      height:16px;
      margin-right:5px;
      transform: rotate(180deg);
    }
  }
</style>